import {
    createActionComparatorFactory,
    createActionTypeFactory,
    createNamespaceActionCreatorFactory,
    createNamespaceReducerFactory,
    createNamespaceSelectorFactory,
    IActionComparatorFactory,
    IActionReducerFactory,
    IActionTypeFactory,
    INamespaceActionCreatorFactory,
    ISelectorFactory,
} from '@omaze/redux';

import { IFeatureFlagState } from './FeatureFlag.state';

export const FEATURE_FLAG_NAMESPACE: string = 'feature_flag';

export const createFeatureFlagActionType: IActionTypeFactory = createActionTypeFactory(
    FEATURE_FLAG_NAMESPACE,
);
export const createFeatureFlagReducerFactory: IActionReducerFactory<IFeatureFlagState> = createNamespaceReducerFactory<
IFeatureFlagState
>(FEATURE_FLAG_NAMESPACE);
export const createFeatureFlagActionCreatorFactory: INamespaceActionCreatorFactory = createNamespaceActionCreatorFactory(
    FEATURE_FLAG_NAMESPACE,
);
export const createFeatureFlagActionComparator: IActionComparatorFactory = createActionComparatorFactory(
    FEATURE_FLAG_NAMESPACE,
);

export const createFeatureFlagSelector: ISelectorFactory<IFeatureFlagState> = createNamespaceSelectorFactory<
IFeatureFlagState
>(FEATURE_FLAG_NAMESPACE);
